import React from 'react';
import SSCChecker from './ssc';

function App() {
  return (
    <div className="min-h-screen bg-gray-100 text-gray-800">
      <SSCChecker />
    </div>
  );
}

export default App;
